import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { treatmentTemplateList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
// `filters` may be a search string (legacy) or an object:
// { q, name, diagnosis, medical_tests, special_instructions, start_date, end_date }
const UseFetchTreatmentTemplateList = (page, pageSize, filters) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["treatmentTemplateList", page, pageSize, filters],
        queryFn: () => treatmentTemplateList(page, pageSize, filters),
        enabled: !!page || !!pageSize || !!filters,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchTreatmentTemplateList;
